/**
 * Created by jv on 2019-09-26 (15:56).
 */

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import InvestmentsView from "Sources/components/game/components/investments-view";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/investment-card.scss");
require("Styles/components/business-model-dialog.scss");
require("Styles/components/investment-dialog.scss");

class InvestmentDialog
{
    constructor(options)
    {
        // this.dialogId = utils.generateElementId("investment-dialog-");
        this.$dialog = $(".investment-dialog");
        this.investment = options.investment;

        this.team = options.team;
        this.roundOverview = options.roundOverview;
        this.investments = options.investments;

        this.callbackContext = options.callbackContext;
        this.onCancel = options.onCancel;
        this.onPurchase = options.onPurchase;
    }

    get currentRoundData()
    {
        return this.roundOverview.currentRoundData;
    }

    get isOpen()
    {
        return utils.isNotNull(this.$dialog) && this.$dialog.length && !this.$dialog.hasClass("hidden");
    }

    create()
    {
        if (this._initialized !== true)
        {
            this.renderDialog();

            this.$dialog.appendTo("#game-view-wrapper");
            this.initialize();
        }
    }

    initialize()
    {
        if (this._initialized !== true)
        {
            // this.$dialog.modal({
            //   backdrop: false,
            //   show: false
            // });

            // this.setUpDialogEventListeners();

            this._initialized = true;
        }
    }

    renderDialog()
    {
        // this.$dialog = $("<div id='" + this.dialogId + "' class='modal game-modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
        //   "<div class='modal-dialog modal-dialog-centered business-model-dialog investment-dialog'>" +
        //   "<div class='modal-content'>" +
        //   "</div>" +
        //   "</div>" +
        //   "</div>");

        this.renderDialogContent();
    }

    renderDialogContent()
    {
        if (utils.isNull(this.investment)) return;

        let $dialogContent = this.$dialog.find(".investment-content");

        if (utils.isNotNull($dialogContent) && $dialogContent.length)
        {
            // $dialogContent.empty();

            log.debug("Setting up investment dialog card for investment - %o", this.investment);

            this.$dialog.find(".investment-cost label").text("-" + this.investment.cost);

            if (this.investment.points > 0)
            {
                this.$dialog.find(".investment-points").show();
                this.$dialog.find(".investment-points label").text("+" + this.investment.points);
            }
            else
            {
                this.$dialog.find(".investment-points").hide();
            }

            this.setUpInvestmentEventListeners();
        }
    }

    setPurchaseButtonLoading(flag)
    {
        let $purchaseBtn = this.$dialog.find(".purchase-investment-btn");
        $purchaseBtn.removeClass("btn-loading").prop("disabled", flag);

        if (flag)
        {
            $purchaseBtn.addClass("btn-loading");
        }
    }

    show(asInfo)
    {
        this.showAsInfo = asInfo;
        this.cancelShow = false;
        this.setPurchaseButtonLoading(false);
        this.renderDialogContent();
        this.$dialog.removeClass("hidden");

        if (asInfo === true)
        {
            $(".investment-header").hide();
            $(".purchase-investment-btn").hide();
        }
        else
        {
            $(".investment-header").show();
            $(".purchase-investment-btn").show();
        }
    }

    hide()
    {
        this.cancelShow = true;
        this.$dialog.addClass("hidden");
    }

    destroy()
    {
        if (utils.isNotNull(this.$dialog) && this.$dialog.length)
        {
            this.$dialog.remove();
        }
    }

    setUpDialogEventListeners()
    {
        this.$dialog.on("show.bs.modal", (e) =>
        {
            if (this.cancelShow)
            {
                this.cancelShow = false;
                e.preventDefault();
            }
        });

        this.$dialog.on("shown.bs.modal", (e) =>
        {
            if (this.cancelShow)
            {
                this.cancelShow = false;
                this.hide();
            }
        });

        this.$dialog.on("hide.bs.modal", (e) =>
        {
            this.cancelShow = false;
        });

        this.$dialog.on("hidden.bs.modal", (e) =>
        {
            this.cancelShow = false;
        });
    }

    setUpInvestmentEventListeners()
    {
        this.$dialog.find(".btn").off("transitionend").on("transitionend", (e) =>
        {
            // transitionend fix for dialog close animations
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        this.$dialog.find(".dialog-close-btn").off("click").on("click", (e) =>
        {
            if (utils.isFunction(this.onCancel))
            {
                this.onCancel.call(this.callbackContext, this);
            }
        });

        this.$dialog.find(".purchase-investment-btn").off("click").on("click", (e) =>
        {
            if (utils.isFunction(this.onPurchase))
            {
                this.onPurchase.call(this.callbackContext, this);
            }
        });
    }
}

export default InvestmentDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/investment-dialog.js